import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Cuerpo } from './pages/Cuerpo';
import { Mente } from './pages/Mente';
import { Espiritu } from './pages/Espiritu';
import { Relaciones } from './pages/Relaciones';
import { Finanzas } from './pages/Finanzas';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3fbjd393le3y2">
      <Routes data-id="element-1" data-mp="3fb15jgbhc3au">
        <Route path="/" element={<Cuerpo data-id="element-3" data-mp="2rkx67l5bqppn" />} data-id="element-2" data-mp="3f8ez5k0brtu7" />
        <Route path="/mente" element={<Mente data-id="element-5" data-mp="2rlf7wxar9w4y" />} data-id="element-4" data-mp="2rk45b0t1quff" />
        <Route path="/espiritu" element={<Espiritu data-id="element-7" data-mp="2mm2nej7cx15j" />} data-id="element-6" data-mp="2rit1x23ijoou" />
        <Route path="/relaciones" element={<Relaciones data-id="element-9" data-mp="2mnngs5hxqe1t" />} data-id="element-8" data-mp="2mmvl6uoc8gbj" />
        <Route path="/finanzas" element={<Finanzas data-id="element-11" data-mp="31ayplzmqfjy8" />} data-id="element-10" data-mp="31aqd48uiugnk" />
        <Route path="*" element={<Cuerpo data-id="element-13" data-mp="31ctf7r8y808n" />} data-id="element-12" data-mp="31c9uy3vtszrg" />
      </Routes>
    </BrowserRouter>;
}